const types = {
  RESTART_GAME: "RESTART_GAME",
  END_GAME: "END_GAME",
  GAME_ENDED_MESSAGE: "GAME_ENDED_MESSAGE",
  PLAYER_POSITION: "PLAYER_POSITION",
  SANDWICH_POSITION: "SANDWICH_POSITION",
  SANDWICH_POINTS: "SANDWICH_POINTS",
  RED_GHOST_POSITION: "RED_GHOST_POSITION",
  DECREASE_BOARD_SIZE: "DECREASE_BOARD_SIZE",
  CHANGE_GHOST_SPEED: "CHANGE_GHOST_SPEED",
  SET_TIMER: "SET_TIMER",
  RESET_TIMER: "RESET_TIMER",
  GAME_OVER_DUE_TO_TIME: "GAME_OVER_DUE_TO_TIME",
  DISPLAY_INSTRUCTIONS: "DISPLAY_INSTRUCTIONS",
  DISPLAY_HIGH_SCORE: "DISPLAY_HIGH_SCORE",
};

export default types;
